export default __webpack_public_path__ + "media/images/favicon/apple-touch-icon-120x120-b4f4ee339a51d18aa57cbfb62993fffb.png";